/** Вход */
export default {
  label: {
    code: 'Вход по SMS',
    pswd: 'Вход по паролю'
  },
  phone: 'Номер телефона',
  password: 'Пароль для входа',
  code: '{type} верификация',
  sms: 'SMS',
  img: 'Изображение',
  getCode: 'Отправить',
  login: 'Вход',
  // Выбор продавца
  choose: 'Выберите продавца',
  // Подсказки
  agree: 'Незарегистрированные номера телефонов будут автоматически зарегистрированы. Отметка означает ваше согласие и принятие',
  agreement: '《Пользовательское соглашение платформы продавца》',
  second: 'с',
  // Вход через WeChat
  wx: 'Вход через WeChat',
  // Платформа управления мероприятиями
  activity_platform: {
    title: 'Платформа управления мероприятиями',
    subtitle: 'От простого к сложному, бесконечные вариации и настройки для удовлетворения ваших потребностей в мероприятиях',
    features: [
      'Публикация крупных мероприятий через несколько раундов и категорий групп',
      'Увеличение охвата ваших мероприятий через рейтинги популярности',
      'Достижение многообразного продвижения через загрузку рекламы',
      'Точный выбор лучших участников через многомерную оценку',
      'Демонстрация красочных сцен через загрузку изображений и видео'
    ]
  },
  // Оценка и повышение
  evaluation: {
    title: 'Оценка и повышение',
    subtitle: 'Многомерная оценка для наиболее справедливого и формального отбора',
    features: [
      'Создание многомерных схем оценки для разных групп, комплексный отбор',
      'Выбор между оценкой и судейством',
      'Несколько судей оценивают и выставляют баллы одновременно для обеспечения справедливости',
      'Однокнопочная операция для отбора участников, повышения и отсева',
      'Создание сертификатов и рейтингов для выдающихся участников'
    ]
  },
  // Замечательные моменты
  moments: {
    title: 'Замечательные моменты',
    subtitle: 'Запись драгоценных моментов мероприятий через изображения и видео',
    features: [
      'Загрузка изображений или видео, публикация на мобильных устройствах как памятные моменты',
      'Эффективное управление через теги и категории изображений и видео',
      'Скачивание изображений и видео для пользователей для постоянного хранения ярких моментов'
    ]
  },
  // Рейтинги популярности
  popularity: {
    title: 'Рейтинги популярности',
    subtitle: 'Идеальное отражение популярности мероприятий через рейтинговые списки',
    features: [
      'Рейтинги лайков, один голос на человека показывает высокую популярность мероприятия',
      'Рейтинги подарков, внесите свой вклад в поддержку популярных участников',
      'Многоэтапные рейтинги показывают разную популярность на разных этапах',
      'Рейтинги по группам показывают популярных участников в разных группах'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/ru/login.js